import { classnames } from '@aibees/shared/utils';
import { Avatar, AvatarGroup } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { EmptySearchResultAvatarProps as Props } from './types';
import { useGetAvatarBasedOnSearchType } from './use-get-avatar-based-on-search-type';

export const EmptySearchResultAvatar = memo(({ className }: Props) => {
  const list = useGetAvatarBasedOnSearchType();
  return (
    <Styled.Wrapper
      className={classnames('EmptySearchResultAvatar', className)}
      sx={SX.root}
    >
      <AvatarGroup max={6}>
        {list.map((x, i) => (
          <Avatar
            key={i.toString()}
            sx={{ width: 40, height: 40 }}
            src={x}
            slotProps={{
              img: { alt: '', width: 40, height: 40 },
            }}
          />
        ))}
      </AvatarGroup>
    </Styled.Wrapper>
  );
});

EmptySearchResultAvatar.displayName = 'EmptySearchResultAvatar';
